
<div class="error-text" ><h3 *ngFor="let errorMessage of listErrors(); let last=last"> {{last ? errorMessage: ''}}</h3></div>